<template>
  <el-row>
    <el-tabs type="border-card">
      <!-- 1、横向对比 -->
      <el-tab-pane label="横向对比">
        <!-- 搜索栏 -->
        <div class="form">
          <el-form :inline="true" :model="formInline1" class="demo-form-inline">
            <el-form-item label="市场">
              <el-select v-model="formInline1.market" placeholder="选择市场" size="mini">
                <el-option v-for="item in options_market" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="主体类型">
              <el-select v-model="formInline1.industry" placeholder="选择行业" size="mini">
                <el-option v-for="item in options_industry" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="时间粒度">
              <el-select v-model="formInline1.timeType" placeholder="选择时间粒度" size="mini" @change="resetPagination">
                <el-option v-for="item in optionsTime" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="时间">
              <el-date-picker v-if="formInline1.timeType === 'month'" v-model="formInline1.pre_date" type="month" size="mini" placeholder="选择月"></el-date-picker>
              <quter-component v-if="formInline1.timeType === 'quarter'" v-model="formInline1.quarter_date"></quter-component>
              <half-year v-if="formInline1.timeType === 'half_year'" v-model="formInline1.pre_date"></half-year>
            </el-form-item>
            <el-form-item>
              <el-button class="grayish_btn" @click="onSubmit1(currentPage)" icon="el-icon-search" size="mini">查询</el-button>
            </el-form-item>
          </el-form>
        </div>

        <!-- 第二层表格与图像 -->
        <div class="two">
          <el-card :body-style="{ padding: 0 }" style="width: 100%;">
            <span class="superscript" style="width: 20px; height: 40px;">影响力排名</span>
            <div class="content">
              <div class="table" style="width: 100%; float: left;">
                <el-table
                    :data="tableData"
                    :header-cell-style="{ background: 'rgba(242, 242, 242, 0.654901960784314)' }"
                    border
                    :row-style="{ height: '28px' }"
                    :cell-style="{ padding: '0px' }"
                    header-row-class-name="active_header"
                    header-cell-class-name="active_header"
                    cell-class-name="content_center"
                    style="width: 98%"
                >
                  <el-table-column v-for="(val, key) in tableLabel" :prop="key" :label="val" :key="key" sortable />
                  <el-table-column prop="scale" label="操作">
                    <template slot-scope="scope">
                      <span class="text" @click="detail(scope.row)">查看详情</span>
                    </template>
                  </el-table-column>
                </el-table>
                <!-- 分页组件 -->
                <div class="pagination" style="margin-top: 20px; text-align: center;">
                  <el-pagination
                      layout="prev, pager, next"
                      :total="total"
                      :page-size="10"
                      v-model:current-page="currentPage"
                      @current-change="handlePageChange"
                  />
                </div>
              </div>
              <div class="bar" style="width: 100%; float: left; overflow: hidden;">
                <div ref="echarts_3" :style="{ height: '400px', width: '100%' }"></div>
              </div>
            </div>
          </el-card>
        </div>
      </el-tab-pane>

      <!-- 2、纵向对比 -->
      <el-tab-pane label="纵向对比">
        <!-- 搜索栏 -->
        <div class="form">
          <el-form :inline="true" :model="formInline1" class="demo-form-inline">
            <el-form-item label="市场">
              <el-select v-model="formInline1.market" placeholder="选择市场" size="mini">
                <el-option v-for="item in options_market" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="主体类型">
              <el-select v-model="formInline1.industry" placeholder="选择行业" size="mini">
                <el-option v-for="item in options_industry" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="时间粒度">
              <el-select v-model="formInline1.timeType" placeholder="选择时间粒度" size="mini" @change="resetPagination">
                <el-option v-for="item in optionsTime" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="开始时间">
              <el-date-picker v-if="formInline1.timeType === 'month'" v-model="formInline1.start_pre" type="month" size="mini" placeholder="选择月"></el-date-picker>
              <quter-component v-if="formInline1.timeType === 'quarter'" v-model="formInline1.start_quarter"></quter-component>
              <half-year v-if="formInline1.timeType === 'half_year'" v-model="formInline1.start_pre"></half-year>
            </el-form-item>
            <el-form-item label="结束时间">
              <el-date-picker v-if="formInline1.timeType === 'month'" v-model="formInline1.end_pre" type="month" size="mini" placeholder="选择月"></el-date-picker>
              <quter-component v-if="formInline1.timeType === 'quarter'" v-model="formInline1.end_quarter"></quter-component>
              <half-year v-if="formInline1.timeType === 'half_year'" v-model="formInline1.end_pre"></half-year>
            </el-form-item>
            <el-form-item>
              <el-button class="grayish_btn" @click="onSubmit4" icon="el-icon-search" size="mini">查询</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="table" style="overflow: hidden">
          <el-table
              :data="historyData"
              :header-cell-style="{ background: 'rgba(242, 242, 242, 0.654901960784314)' }"
              border
              :height="historyTableHeight"
              :row-style="{ height: '28px' }"
              :cell-style="{ padding: '0px' }"
              header-row-class-name="active_header"
              header-cell-class-name="active_header"
              cell-class-name="content_center"
          >
            <el-table-column v-for="(val, key) in timeLis" :prop="key" :label="val" :key="key" />
          </el-table>
        </div>
        <div>
          <!-- 详细信息弹窗，默认关闭 -->
          <el-dialog :visible.sync="detailsdialog" width="100%" @open="open()" :modal="false">
            <el-card>
              <!-- 详细信息 -->
              <el-card style="height: 600px; margin-bottom: 10px;" :body-style="{ padding: 0 }">
                <span class="superscript" style="width: 20px; height: 40px;">详细信息</span>
                <el-table
                    :data="detailData"
                    :header-cell-style="{ background: 'rgba(242, 242, 242, 0.654901960784314)' }"
                    border
                    :row-style="{ height: '28px' }"
                    :cell-style="{ padding: '0px' }"
                    header-row-class-name="active_header"
                    header-cell-class-name="active_header"
                    cell-class-name="content_center"
                    style="margin: 15px;"
                >
                  <el-table-column prop="comp_name" label="主体名称" width="120" />
                  <el-table-column label="市场结构">
                    <el-table-column prop="DC" label="度中心性" width="120" />
                    <el-table-column prop="BC" label="介数中心性" width="120" />
                    <el-table-column prop="CC" label="接近中心性" width="120" />
                    <el-table-column prop="weighted-PR" label="加权PageRank" width="120" />
                  </el-table-column>
                  <el-table-column label="个体规模">
                    <el-table-column prop="region" label="所在区域" width="120" />
                    <el-table-column prop="held_num" label="持股数量(股)" width="120" />
                    <el-table-column prop="asset" label="当前资金规模(万)" width="120" />
                  </el-table-column>
                  <el-table-column prop="Total_score" label="影响力综合分数" width="120" />
                  <el-table-column prop="grade" label="影响等级" width="120" />
                </el-table>
                <div style="display: flex;">
                  <el-divider direction="vertical" class="sublabel"></el-divider>
                  <span class="title">个体规模分析</span>
                </div>
                <DifferentialChart :asset="asset" :datelis="datelis" :held_num="held_num" />
              </el-card>
              <!-- 关联主体 -->
              <el-card style="height: 300px; margin-bottom: 10px" :body-style="{ padding: 0 }">
                <span class="superscript" style="width: 20px; height: 40px;">关联主体</span>
                <div class="form">
                  <el-form :inline="true" :model="formInline2" class="demo-form-inline" style="margin: 10px;">
                    <template>
                      <el-radio v-model="typeRela" label="key_node">关键节点</el-radio>
                      <el-radio v-model="typeRela" label="other">相似节点</el-radio>
                    </template>
                    <el-form-item>
                      <el-button class="grayish_btn" @click="onSubmit2" icon="el-icon-search" size="mini">查询</el-button>
                    </el-form-item>
                  </el-form>
                </div>
                <div style="display: flex; padding-left: 130px" v-if="showRelated">
                  <el-button v-for="(val, key) in relatedRes" :key="key" round style="height: 100px; width: 300px; margin-right: 50px">{{ val }}</el-button>
                </div>
              </el-card>
            </el-card>
          </el-dialog>
        </div>
      </el-tab-pane>
    </el-tabs>
  </el-row>
</template>

<script>
import * as echarts from "echarts";
import http from "../utils/request";
import DifferentialChart from "@/components/echarts/DifferentialChart.vue";
import halfYear from "@/components/halfYear";
import quterComponent from "@/components/quterComponent";
import qs from "qs";
import { Loading } from "element-ui";

export default {
  name: "influential_entities",
  components: {
    DifferentialChart,
    halfYear,
    quterComponent,
  },
  data() {
    return {
      total: 0,
      totalPages: 0,
      currentPage: 1,
      datelis: [],
      asset: [],
      held_num: [],
      width: null,
      result: {},
      showRelated: false,
      relatedRes: [],
      seleced: "",
      typeRela: null,
      typeSpread: null,
      totalRisk: Number,
      totalType: Number,
      detailsdialog: false,
      detailData: [{ 主体名称: "主体1" }],
      options_market: [
        { value: "stock", label: "股票" },
        { value: "期货", label: "期货" },
        { value: "债券", label: "债券" },
      ],
      optionsTime: [
        { label: "半年", value: "half_year" },
        { label: "季度", value: "quarter" },
        { label: "月", value: "month" },
      ],
      options_industry: [
        { label: "机构投资者", value: "institutional_investors" },
        { label: "私募", value: "PrivFund" },
        { label: "上市企业", value: "listedComp" },
        { label: "海外机构", value: "ForeignComp" },
        { label: "量化机构", value: "QuantFund" },
      ],
      formInline1: {
        timeType: "",
        quarter_date: "",
        pre_date: "",
        market: "",
        industry: "",
        start_pre: "",
        start_quarter: "",
        end_pre: "",
        end_quarter: "",
      },
      formInline2: { key_nodes: false, transmissibility_max: false },
      formInline3: { regional_selection: false, ndustry_selection: false },
      formInline4: { type: "" },
      pieDataIndus: [],
      pieDataType: [],
      tableData: [],
      tableLabel: {
        comp_name: "主体名称",
        BC: "介数中心性",
        DC: "度中心性",
        CC: "接近中心性",
        weighted_PR: "加权PageRank",
        SLC: "局部中心性",
        Total_score: "影响力综合分数",
        grade: "影响等级",
        spread_ability: "传播能力",
      },
      historyData: [],
      timeLis: [],
      historyDataLabel: { comp_name: "主体名称", Total_score: "影响力综合分数" },
      barData: [],
    };
  },
  computed: {
    tableHeight() {
      const rowHeight = 28;
      const headerHeight = 40;
      return (this.tableData.length * rowHeight) + headerHeight; // 根据数据条数动态计算高度
    },
    historyTableHeight() {
      const rowHeight = 28;
      const headerHeight = 40;
      return (this.historyData.length * rowHeight) + headerHeight; // 纵向对比表格动态高度
    },
  },
  mounted() {
    this.initializeCharts();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.$forceUpdate();
    },
    initializeCharts() {
      try {
        const echarts1 = echarts.init(this.$refs.echarts_1);
        const echarts2 = echarts.init(this.$refs.echarts_2);
        http
            .get("/risk_model/get_data/")
            .then((response) => {
              for (let key in response.data["行业分布"]) {
                this.pieDataIndus.push({ name: key, value: response.data["行业分布"][key] });
              }
              for (let key in response.data["风险分布"]) {
                this.pieDataType.push({ name: key, value: response.data["风险分布"][key] });
              }
              this.totalType = response.data["风险类型"];
              this.totalRisk = response.data["个体总数"];
              const option_1 = {
                toolbox: { feature: { saveAsImage: {} } },
                tooltip: { trigger: "item" },
                title: {
                  text: "风险行业分布",
                  x: "center",
                  y: "bottom",
                  textStyle: { fontSize: 13, color: "#696969" },
                  padding: [35, 0, 5, 0],
                },
                series: [
                  {
                    data: this.pieDataIndus,
                    type: "pie",
                    avoidLabelOverlap: true,
                    minAngle: 5,
                  },
                ],
              };
              const option_2 = {
                toolbox: { feature: { saveAsImage: {} } },
                tooltip: { trigger: "item" },
                title: {
                  text: "风险类型分布",
                  x: "center",
                  textStyle: { fontSize: 13, color: "#696969" },
                  padding: [5, 0, 20, 0],
                },
                series: [{ data: this.pieDataType, type: "pie" }],
              };
              this.$nextTick(() => {
                echarts1.setOption(option_1);
                echarts2.setOption(option_2);
              });
            })
            .catch((error) => {
              console.error("饼状图数据加载失败:", error);
            });
      } catch (error) {
        console.error("初始化饼状图失败:", error);
      }
    },
    resetPagination() {
      this.currentPage = 1;
      this.tableData = [];
      this.barData = [];
      this.total = 0;
      this.totalPages = 0;
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.onSubmit1(page);
    },
    onSubmit1(page = 1) {
      console.log("影响力排名");
      console.log("时间参数:", this.formInline1);
      let options = { text: "请稍等" };
      let loadingInstance = Loading.service(options);
      const isQuarter = this.formInline1.timeType === "quarter";
      const timeValue = isQuarter ? this.formInline1.quarter_date : this.formInline1.pre_date;

      if (!this.formInline1.market || !this.formInline1.industry || !timeValue || !this.formInline1.timeType) {
        loadingInstance.close();
        alert("请填写完整搜索条件");
        return;
      }

      http
          .get("/rank/network/", {
            params: {
              market: this.formInline1.market,
              com_type: this.formInline1.industry,
              time: timeValue,
              time_type: this.formInline1.timeType,
              page: page,
              page_size: 10,
            },
            paramsSerializer: (params) => {
              return qs.stringify(params, { indices: false });
            },
          })
          .then((response) => {
            loadingInstance.close();
            if (!response.data || response.data.data.length === 0) {
              alert("没有结果");
              this.tableData = [];
              this.barData = [];
              this.total = 0;
              this.totalPages = 0;
            } else {
              let dat = response.data;
              this.tableData = Array.isArray(dat.data) ? dat.data : [];
              this.barData = Array.isArray(dat.data) ? dat.data : [];
              this.total = dat.total || 0;
              this.totalPages = Math.ceil(this.total / 10);
              console.log("数据:", this.tableData);
              this.result = dat.data;
              this.$nextTick(() => {
                if (this.$refs.echarts_3) {
                  const echarts3 = echarts.init(this.$refs.echarts_3);
                  const option_3 = {
                    toolbox: { feature: { saveAsImage: {} } },
                    legend: { textStyle: { color: "#333" } },
                    grid: { left: "20%" },
                    tooltip: { trigger: "axis", axisPointer: { type: "shadow" } },
                    xAxis: { type: "category", data: this.barData.map((item) => item.comp_name || "未知") },
                    yAxis: [{ type: "value" }],
                    title: {
                      text: "中心性分析",
                      x: "center",
                      y: "bottom",
                      textStyle: { fontSize: 13 },
                      padding: [5, 0, 10, 0],
                    },
                    series: [
                      { name: "介接近中心性", data: this.barData.map((item) => item.CC || 0), type: "bar" },
                      { name: "介数中心性", data: this.barData.map((item) => item.BC || 0), type: "bar" },
                      { name: "加权PageRank", data: this.barData.map((item) => item["weighted-PR"] || 0), type: "bar" },
                      { name: "度中心性", data: this.barData.map((item) => item.DC || 0), type: "bar" },
                    ],
                  };
                  echarts3.setOption(option_3);
                } else {
                  console.warn("echarts_3 ref not found");
                }
              });
            }
          })
          .catch((error) => {
            console.error("请求失败:", error);
            loadingInstance.close();
            this.tableData = [];
            this.barData = [];
            this.total = 0;
            this.totalPages = 0;
          });
    },
    onSubmit2() {
      this.relatedRes.length = 0;
      http
          .get("/rank/relate/", {
            params: {
              name: this.seleced,
              type: this.typeRela,
              market: this.formInline1.market,
              industry: this.formInline1.industry,
              start_date: this.formInline1.start_pre || this.formInline1.start_quarter,
              end_date: this.formInline1.end_pre || this.formInline1.end_quarter,
            },
          })
          .then((res) => {
            if (res.data !== "null") {
              this.relatedRes.length = 0;
              for (let i in res.data) {
                this.relatedRes.push(res.data[i]);
              }
              console.log(this.relatedRes);
              this.showRelated = true;
            } else {
              this.$message({ showClose: true, message: "未查询到结果", type: "info" });
            }
          });
    },
    onSubmit3() {
      http
          .get("/rank/spread/", {
            params: {
              name: this.seleced,
              type: this.typeSpread,
              market: this.formInline1.market,
              industry: this.formInline1.industry,
              start_date: this.formInline1.start_pre || this.formInline1.start_quarter,
              end_date: this.formInline1.end_pre || this.formInline1.end_quarter,
            },
          })
          .then((res) => {
            console.log(res.data.data);
          });
    },
    onSubmit4() {
      if (this.formInline1.timeType !== "quarter") {
        http
            .get("/rank/history/", {
              params: {
                market: this.formInline1.market,
                com_type: this.formInline1.industry,
                time_type: this.formInline1.timeType,
                start: this.formInline1.start_pre,
                end: this.formInline1.end_pre,
              },
              paramsSerializer: (params) => {
                return qs.stringify(params, { indices: false });
              },
            })
            .then((res) => {
              if (res.data.length === 0) alert("没有结果");
              else {
                this.historyData = res.data.data;
                this.timeLis = res.data.time;
              }
            });
      } else {
        http
            .get("/rank/history/", {
              params: {
                market: this.formInline1.market,
                com_type: this.formInline1.industry,
                time_type: this.formInline1.timeType,
                start: this.formInline1.start_quarter,
                end: this.formInline1.end_quarter,
              },
              paramsSerializer: (params) => {
                return qs.stringify(params, { indices: false });
              },
            })
            .then((res) => {
              if (res.data.length === 0) alert("没有结果");
              else {
                this.historyData = res.data.data;
                this.timeLis = res.data.time;
              }
            });
      }
    },
    getSpanArr(list) {
      list.forEach((item) => {
        item.rowspan = 1;
      });
      for (let i = 0; i < list.length; i++) {
        for (let j = i + 1; j < list.length; j++) {
          if (list[i].duration === list[j].duration) {
            list[i].rowspan++;
            list[j].rowspan--;
          }
        }
        i = i + list[i].rowspan - 1;
      }
      this.historyData.length = 0;
      this.historyData = list;
      console.log(this.historyData);
    },
    detail(row) {
      this.seleced = row.comp_name;
      this.datelis.length = 0;
      this.asset.length = 0;
      this.held_num.length = 0;
      http
          .get("/rank/asset/", { params: { comp_name: this.seleced } })
          .then((res) => {
            for (let i in res.data) {
              this.datelis.push(res.data[i]["duration"].slice(0, 11));
              this.asset.push(res.data[i]["asset"]);
              this.held_num.push(res.data[i]["held_num"]);
            }
          });
      this.detailData.length = 0;
      for (let i in this.tableData) {
        if (this.tableData[i]["comp_name"] === this.seleced) this.detailData = [this.tableData[i]];
      }
      console.log(this.detailData);
      this.detailsdialog = true;
    },
    initEcharts() {
      const echarts4 = echarts.init(this.$refs.echarts_4);
      const option_4 = {
        title: {
          text: "影响范围统计-行业",
          left: "center",
          textStyle: { fontSize: 17, lineHeight: 60 },
        },
        tooltip: {},
        xAxis: {
          data: ["银行", "保险", "运输"],
          name: "行业",
          nameTextStyle: { padding: [0, 0, -40, -260], verticalAlign: "bottom" },
        },
        yAxis: {
          name: "影响行业的数量",
          axisTick: { show: true },
          axisLine: { show: true },
          nameTextStyle: {
            position: "left",
            nameLocation: "middle",
            nameGap: 60,
            nameRotate: 90,
          },
        },
        series: [
          {
            name: "数量",
            type: "bar",
            data: [45, 20, 30],
            barWidth: 60,
            itemStyle: {
              normal: {
                color: function (params) {
                  let colorList = ["blue", "green", "red"];
                  return colorList[params.dataIndex];
                },
                label: { show: true, position: "top" },
              },
            },
          },
        ],
      };
      echarts4.setOption(option_4);

      const echarts5 = echarts.init(this.$refs.echarts_5);
      const option_5 = {
        title: {
          text: "影响行业占比份额",
          left: "center",
          textStyle: { fontSize: 17, lineHeight: 85 },
        },
        tooltip: { trigger: "item" },
        legend: { orient: "vertical", left: "30", top: "40" },
        series: [
          {
            name: "占比份额",
            type: "pie",
            radius: "55%",
            LabelOverlap: true,
            data: [
              { value: 45, name: "银行" },
              { value: 20, name: "保险" },
              { value: 30, name: "运输" },
            ],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
              borderWidth: 2,
              borderColor: "#fff",
            },
          },
        ],
      };
      echarts5.setOption(option_5);
    },
    open() {
      this.$nextTick(() => {
        this.initEcharts();
      });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-checkbox__label {
  padding-right: 40px;
  padding-left: 40px;
}
.grayish_btn {
  color: #fff;
  background-color: #aaaaaa;
}
/deep/ .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: 1px solid rgba(242, 242, 242, 0.654901960784314) !important;
  padding: 0px 0 !important;
  min-width: 0 !important;
}
.el-table .el-table__cell {
  padding: 12px 0;
  min-width: 0;
}
/deep/ .active_header {
  color: #333333;
  text-align: center !important;
}
/deep/ .content_center {
  text-align: center !important;
}
.text {
  color: rgba(2, 167, 240, 0.729411764705882);
}
.form {
  display: flex;
  justify-content: space-between;
  padding-left: 10px;
  margin-bottom: 0px;
  padding-bottom: 0px;
}
.two .content .table {
  padding: 20px 10px 2px 10px;
}
.two .content .bar {
  padding: 20px 40px 2px 2px;
}
.grayish_btn {
  margin-bottom: 20px;
}
.sublabel {
  margin-top: 10px;
  background-color: rgba(2, 167, 240, 0.5);
  width: 5px;
  height: 35px;
}
.title {
  padding-left: 4px;
  margin-top: 15px;
  font-weight: bold;
  display: flex;
  justify-content: flex-start;
}
</style>